import JsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { formatAccounting } from '../lib/utils'

export default function generatePurchaseReceiptPDF(receipt) {
  const doc = new JsPDF()

  const formatDate = (date) => {
    if (!date) return '-'

    return new Date(date).toLocaleDateString('en-PH', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })
  }

  // HEADER
  doc.setFontSize(20)
  doc.setFont(undefined, 'bold')
  doc.text(process.env.VUE_APP_CLIENT_NAME || 'LBPOULTRY', 14, 18)

  doc.setFontSize(16)
  doc.text('Purchase Receipt', 14, 28)

  doc.setFont(undefined, 'normal')
  doc.setFontSize(11)

  const supplier =
    receipt.receipts?.[0]?.supplier_name || receipt.supplier_name || '-'

  // DETAILS
  const details = [
    ['Receipt No', receipt.receipt_no || '-'],
    ['Supplier', supplier],
    ['Date Received', formatDate(receipt.date_recieved)],
    ['Items', receipt.receipts?.length || 0],
  ]

  autoTable(doc, {
    startY: 35,
    body: details,
    theme: 'plain',
    styles: {
      fontSize: 10,
      cellPadding: 1.5,
    },
    columnStyles: {
      0: {
        fontStyle: 'bold',
        cellWidth: 40,
      },
    },
  })

  // ITEMS
  const tableRows = (receipt.receipts || []).map((item, index) => [
    index + 1,
    item.stock_code || '-',
    item.product_name || '-',
    item.brand_name || '-',
    item.unit || '-',
    item.quantity || 0,
    formatAccounting(item.cost || 0),
    formatAccounting(item.total_amount || 0),
  ])

  autoTable(doc, {
    startY: doc.lastAutoTable.finalY + 10,
    head: [['#', 'Code', 'Product', 'Brand', 'Unit', 'Qty', 'Cost', 'Amount']],
    body: tableRows,
    styles: {
      fontSize: 8,
      cellPadding: 2,
      overflow: 'linebreak',
    },
    headStyles: {
      fillColor: [41, 128, 185],
    },
    columnStyles: {
      5: { halign: 'center' },
      6: { halign: 'right' },
      7: { halign: 'right' },
    },
  })

  // TOTAL
  doc.setFont(undefined, 'bold')
  doc.setFontSize(11)

  doc.text(
    `Total Purchase Amount: ${formatAccounting(receipt.amount || 0)}`,
    14,
    doc.lastAutoTable.finalY + 12,
  )

  doc.save(`purchase-receipt-${receipt.receipt_no || 'receipt'}.pdf`)
}
